import {
defineCustomElement,
MediaToggleButtonElement
} from "vidstack/elements";

defineCustomElement(MediaToggleButtonElement);